import { styled, TextField } from '@mui/material';

export const CustomTextfield = styled(TextField)`
  .MuiInputBase-root {
    border-radius: 23px;
    color: ${({ theme }) => theme.palette.neutral.greyFont};
    font-weight: 500;
    input:-webkit-autofill,
    input:-webkit-autofill:focus {
      transition:
        background-color 0s 600000s,
        color 0s 600000s !important;
      border-radius: 0px 23px 23px 0px;
    }
    input::placeholder {
      color: ${({ theme }) => theme.palette.grey[600]};
      opacity: 1;
    }
  }
`;

export const LargeTextfield = styled(CustomTextfield)`
  .MuiInputBase-root {
    border-radius: 100px;
  }
`;
